import type StoreService from '@ember-data/store';

interface TrackingAdapter {
  host: string;
  headers: Record<string, string>;
}

/**
 * Fetch report view counts from the counts endpoint.
 * Returns a map of reportId → view count.
 */
export async function fetchReportViewCounts(
  store: StoreService,
  reportIds: string[]
): Promise<Record<string, number>> {
  if (!reportIds.length) return {};

  const adapter = store.adapterFor?.('report-tracking') as TrackingAdapter | undefined;
  if (!adapter?.host) return {};

  const params = new URLSearchParams();
  params.set('filter[report_ids]', reportIds.join(','));

  const url = `${adapter.host}/api/v2/report-trackings/counts?${params.toString()}`;

  try {
    const response = await fetch(url, {
      headers: {
        ...adapter.headers,
        Accept: 'application/json',
      },
    });

    if (!response.ok) return {};

    const json = (await response.json()) as { data?: Record<string, number> };
    return json.data ?? {};
  } catch {
    return {};
  }
}
